import { SplunkIconUrl } from "@p0security/shared/integrations/constants";
import { AwsIntegration } from "@p0security/shared/integrations/resources/aws/types";
import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { GcloudIntegration } from "@p0security/shared/integrations/resources/gcloud/types";
import { SplunkStackComponents } from "@p0security/shared/integrations/resources/splunk-stack/components";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { splunkStackIntegrationInstaller } from "./install/install";

export const SplunkStack = (
  props: Pick<
    InstallProps<typeof SplunkStackComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "resource", []);

  const awsIntegrationDoc = useFirestoreDoc<AwsIntegration>(
    "integrations/aws",
    {
      tenantAware: true,
    }
  );

  const gcloudIntegrationDoc = useFirestoreDoc<GcloudIntegration>(
    "integrations/gcloud",
    {
      tenantAware: true,
    }
  );

  const azureIntegrationDoc = useFirestoreDoc<AzureIntegration>(
    "integrations/azure",
    {
      tenantAware: true,
    }
  );

  const cspConfigs = {
    aws: awsIntegrationDoc,
    gcloud: gcloudIntegrationDoc,
    azure: azureIntegrationDoc,
  };

  return (
    <Install<typeof SplunkStackComponents>
      components={SplunkStackComponents}
      installer={splunkStackIntegrationInstaller(cspConfigs)}
      integration="splunk-stack"
      itemKind={itemKind}
      logo={SplunkIconUrl}
      title={"Splunk Stack Access"}
      {...props}
    />
  );
};
